<template>
    <div id="mentions" class="footer">
        <div class="text text--xsmall">
            Vos données personnelles sont traitées par nous, Antargaz, dont l’adresse est 4, place Victor Hugo 92400 Courbevoie, agissant en qualité de responsable de traitement, conformément à la règlementation européenne et française applicable en matière de protection des données. Le Délégué à la Protection des Données (DPO) est joignable à l’adresse dpo@antargaz.com. En remplissant le formulaire, vous consentez à ce que nous traitions et collections vos données personnelles. Vos données seront utilisées afin que vous puissiez être rappelé par un conseiller Antargaz. Vos données seront supprimées à l’issue de cet échange téléphonique si vous décidez de ne pas souscrire à l’une de nos offres et si vous n’avez pas consenti à ce que vos données soient utilisées à des fins de prospection commerciale. Dans le cas où vous avez consenti à ce que vos données soient utilisées à des fins de prospection commerciale, elles seront transférées à nos services marketing et communication et seront conservées pour une durée maximum de 3 ans. Vous disposez de droits d’accès, de rectification, de suppression et à la portabilité de vos données, de limitation et d’opposition au traitement de vos données. Pour exercer ces droits, vous pouvez envoyer votre requête à dpo@antargaz.com. Vous bénéficiez également du droit d’introduire une réclamation auprès de la Commission nationale informatique et libertés.
        </div>

        <div class="line"></div>

        <div class="text text--xsmall">
            (*) Offre soumise à conditions à voir <a class="link" target="_blank" href="https://www.antargaz.fr/citerne-de-gaz/nos-offres/serenipro">ici</a>.
        </div>

        <div class="baseline text text--small">
            L’énergie est notre avenir, économisons-la !
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Footer'
    }
</script>

<style scoped lang="sass">
    @import ../../common/styles/settings
    @import ../../common/styles/mixins
    @import settings
    @import typography

    .footer
        margin-top: ($l-gap*3)

    .line
        height: 1px
        margin-top: ($l-gap*2)
        margin-bottom:  ($l-gap*2)
        background-color: rgba(0,0,0,.15)

    .basic_link
      color: #0563c1
      text-decoration: underline

    .link
        color: #9bd150
        font-size: inherit
        font-weight: 400
        padding: 0
        text-decoration: none

    .baseline
        text-align: center
        margin-top:  ($l-gap*2.5)

</style>
